import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Badge, CustomTabView, Loading, PageHeader } from '../../../../components'
import {
  imprimirOrdemColeta,
  visualizarOrdemColeta,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import * as colors from '../../../../assets/js/colors'
import {
  buildOrdemColetaReportAnaliticoPath,
  buildOrdemColetaReportPath,
  urlGerarExcelOrdemColeta,
  urlGerarExcelOrdemColetaAnalitico,
} from '../../../../services/api/routes/ordem-coleta.routes'
import Btn from '../../../../components/Btn/Btn'
import TextBtn from '../../../../components/TextBtn/TextBtn'
import { Panel } from 'primereact/panel'
import { TabPanel } from 'primereact/tabview'
import {
  formatVolumeUnitsText,
  renderOrdemColetaQuantityCell,
  renderVolumeUnitsCell,
} from '../ordem-coleta-volume-and-units.helper'

import './VisualizarOrdemColeta.css'

const ABA_ANALITICO = 1

function VisualizarOrdemColeta({ history, dispatch }) {
  // Vars
  const { ordem } = history.location.state
  const { id, descricao } = ordem
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [ordemColetaInfo, setOrdemColetaInfo] = useState(null)
  const [abaAtiva, setAbaAtiva] = useState(0)
  useEffect(() => {
    getOrdemColetaInfo()
  }, [ordem])

  // Events
  const onBtnImprimirClick = async () => {
    try {
      await imprimirOrdemColeta(id)
      // Imprime o modelo da aba aberta: Sintético (padrão) ou Analítico (com os produtos de cada NF)
      const url =
        abaAtiva === ABA_ANALITICO
          ? buildOrdemColetaReportAnaliticoPath(id)
          : buildOrdemColetaReportPath(id)
      window.open(url, '_blank')
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onBtnGerarExcelClick = async () => {
    try {
      // Como o Imprimir, segue a aba aberta: o Analítico traz os produtos de cada NF
      const url =
        abaAtiva === ABA_ANALITICO
          ? urlGerarExcelOrdemColetaAnalitico(id)
          : urlGerarExcelOrdemColeta(id)
      window.open(url)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Helpers
  const getOrdemColetaInfo = async () => {
    try {
      const fetchedInfo = await visualizarOrdemColeta(id)
      setOrdemColetaInfo(fetchedInfo)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Templates
  const customHeader = (
    <div className="p-grid">
      <div className="p-col-3">
        <Btn onClick={onBtnImprimirClick}>Imprimir</Btn>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <Btn onClick={onBtnGerarExcelClick}>Gerar Excel</Btn>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <TextBtn onClick={history.goBack}>Voltar</TextBtn>
        </div>
      </div>
    </div>
  )

  const informacoes = ordemColetaInfo && (
    <InformacoesSection
      company={ordemColetaInfo.company}
      localDescarga={ordemColetaInfo.local_descarga}
      qteTotalCaixas={ordemColetaInfo.qte_total_caixas}
      qteTotalCaixasVolUni={ordemColetaInfo.qte_total_caixas_vol_uni}
      status={ordemColetaInfo.status}
      observacoes={ordemColetaInfo.observacoes}
    />
  )

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Visualizando a Ordem de Coleta: &nbsp;
        <strong>{`${id} - ${descricao}`}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel header={customHeader}>
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <CustomTabView activeIndex={abaAtiva} onTabChange={setAbaAtiva}>
              <TabPanel header="Sintético">
                {informacoes}
                <DevolucaoTotalSection devolucoes={ordemColetaInfo.devolucoes_totais} />
                <DevolucaoParcialSection devolucoes={ordemColetaInfo.devolucoes_parciais} />
                <SobraSection sobras={ordemColetaInfo.sobras} />
              </TabPanel>
              <TabPanel header="Analítico">
                {informacoes}
                <DevolucaoTotalAnaliticoSection devolucoes={ordemColetaInfo.devolucoes_totais} />
                <DevolucaoParcialAnaliticoSection
                  devolucoes={ordemColetaInfo.devolucoes_parciais}
                />
                <SobraSection sobras={ordemColetaInfo.sobras} />
              </TabPanel>
            </CustomTabView>
          )}
        </Panel>
      </div>
    </React.Fragment>
  )
}

function InformacoesSection({
  company,
  status,
  localDescarga,
  qteTotalCaixas,
  qteTotalCaixasVolUni,
  observacoes,
}) {
  // Helper
  const getStatusBadge = () => {
    switch (status) {
      case 'Aberto':
        return <Badge color={colors.laranja}>Aberto</Badge>
      case 'Correcao':
        return <Badge color={colors.vinho}>Correção</Badge>
      case 'Finalizado':
        return <Badge color={colors.azul}>Finalizado</Badge>
      case 'Aprovado':
        return <Badge color={colors.azul_escuro}>Aprovado</Badge>
      case 'Coletado':
        return <Badge color={colors.verde}>Coletado</Badge>
      default:
        return null
    }
  }
  // Render
  return (
    <React.Fragment>
      <h3>Informações</h3>
      <hr />
      <div>
        <div className="p-grid">
          <div className="p-col-2">Status:</div>
          <div className="p-col-4">{getStatusBadge()}</div>
          <div className="p-col-2">Local de Descarga:</div>
          <div className="p-col-4">{localDescarga}</div>

          <div className="p-col-2">Empresa:</div>
          <div className="p-col-4">{company}</div>

          <div className="p-col-2">Total de Caixas:</div>
          <div className="p-col-4">
            <strong>
              {qteTotalCaixasVolUni
                ? formatVolumeUnitsText(qteTotalCaixasVolUni.vol, qteTotalCaixasVolUni.uni)
                : qteTotalCaixas}
            </strong>
          </div>
          {observacoes ? (
            <React.Fragment>
              <div className="p-col-12">
                <strong>Observações:</strong>
              </div>
              <div className="p-col-12">{observacoes}</div>
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  )
}

function DevolucaoTotalSection({ devolucoes }) {
  return (
    <React.Fragment>
      <h3>Devolução Total</h3>
      <hr />
      <div style={{ marginTop: 15 }}>
        {devolucoes.length > 0 ? (
          <DataTable value={devolucoes}>
            <Column
              field="invoice_number_entrega"
              header="NF. Entrega"
              style={{ textAlign: 'center' }}
            />
            <Column field="senha" header="Senha" style={{ textAlign: 'center' }} />
            <Column
              field="qte_caixa_nf"
              header="Qte. Caixa NF."
              style={tableCellCentered(150)}
              body={dev => renderVolumeUnitsCell(dev.qte_caixa_nf_vol_uni.vol, dev.qte_caixa_nf_vol_uni.uni)}
            />
            <Column
              field="qte_devolvida"
              header="Qte. Devolvida."
              style={tableCellCentered(150)}
              body={dev =>
                renderVolumeUnitsCell(dev.qte_devolvida_vol_uni.vol, dev.qte_devolvida_vol_uni.uni)
              }
            />
          </DataTable>
        ) : (
          'Não existe Devolução Total associada a esta Ordem de Coleta'
        )}
      </div>
    </React.Fragment>
  )
}

function DevolucaoParcialSection({ devolucoes }) {
  return (
    <div style={{ marginTop: 10 }}>
      <h3>Devolução Parcial</h3>
      <hr />
      <div style={{ marginTop: 15 }}>
        {devolucoes.length > 0 ? (
          <DataTable value={devolucoes}>
            <Column
              field="invoice_number_cliente"
              header="NF. Cliente"
              style={{ textAlign: 'center' }}
            />
            <Column
              field="invoice_entrega_number"
              header="NF. Entrega"
              style={{ textAlign: 'center' }}
            />
            <Column field="senha" header="Senha" style={{ textAlign: 'center' }} />
            <Column
              field="qte_caixa_nf"
              header="Qte. Caixa NF."
              style={tableCellCentered(150)}
              body={dev => renderVolumeUnitsCell(dev.qte_caixa_nf_vol_uni.vol, dev.qte_caixa_nf_vol_uni.uni)}
            />
            <Column
              field="qte_devolvida"
              header="Qte. Devolvida."
              style={tableCellCentered(150)}
              body={dev =>
                renderVolumeUnitsCell(dev.qte_devolvida_vol_uni.vol, dev.qte_devolvida_vol_uni.uni)
              }
            />
          </DataTable>
        ) : (
          'Não existe Devolução Parcial associada a esta Ordem de Coleta'
        )}
      </div>
    </div>
  )
}

// Aba Analítico: cada NF numa linha destacada, seguida dos seus produtos
function montarLinhasAnalitico(devolucoes) {
  return devolucoes.reduce(
    (linhas, nf) => [
      ...linhas,
      { ...nf, isNf: true },
      ...(nf.produtos || []).map(produto => ({ ...produto, isNf: false })),
    ],
    [],
  )
}

function renderQuantidadeAnalitico(linha, campo) {
  if (linha.isNf) {
    const { vol, uni } = linha[`${campo}_vol_uni`]
    return renderVolumeUnitsCell(vol, uni)
  }
  return renderOrdemColetaQuantityCell(linha, linha[campo])
}

const rowClassNameAnalitico = linha => ({ 'linha-nf-analitico': linha.isNf })

function DevolucaoTotalAnaliticoSection({ devolucoes }) {
  return (
    <React.Fragment>
      <h3>Devolução Total</h3>
      <hr />
      <div style={{ marginTop: 15 }}>
        {devolucoes.length > 0 ? (
          <DataTable value={montarLinhasAnalitico(devolucoes)} rowClassName={rowClassNameAnalitico}>
            <Column
              header="NF. Entrega"
              style={tableCellCentered(130)}
              body={linha => (linha.isNf ? linha.invoice_number_entrega : null)}
            />
            <Column
              header="Senha"
              style={tableCellCentered(110)}
              body={linha => (linha.isNf ? linha.senha : null)}
            />
            <Column
              header="Código"
              style={tableCellCentered(110)}
              body={linha => (linha.isNf ? null : linha.product_code)}
            />
            <Column header="Produto" body={linha => (linha.isNf ? null : linha.product_name)} />
            <Column
              header="Qte. Caixa NF."
              style={tableCellCentered(150)}
              body={linha => renderQuantidadeAnalitico(linha, 'qte_caixa_nf')}
            />
            <Column
              header="Qte. Devolvida."
              style={tableCellCentered(150)}
              body={linha => renderQuantidadeAnalitico(linha, 'qte_devolvida')}
            />
          </DataTable>
        ) : (
          'Não existe Devolução Total associada a esta Ordem de Coleta'
        )}
      </div>
    </React.Fragment>
  )
}

function DevolucaoParcialAnaliticoSection({ devolucoes }) {
  return (
    <div style={{ marginTop: 10 }}>
      <h3>Devolução Parcial</h3>
      <hr />
      <div style={{ marginTop: 15 }}>
        {devolucoes.length > 0 ? (
          <DataTable value={montarLinhasAnalitico(devolucoes)} rowClassName={rowClassNameAnalitico}>
            <Column
              header="NF. Cliente"
              style={tableCellCentered(130)}
              body={linha => (linha.isNf ? linha.invoice_number_cliente : null)}
            />
            <Column
              header="NF. Entrega"
              style={tableCellCentered(130)}
              body={linha => (linha.isNf ? linha.invoice_entrega_number : null)}
            />
            <Column
              header="Senha"
              style={tableCellCentered(110)}
              body={linha => (linha.isNf ? linha.senha : null)}
            />
            <Column
              header="Código"
              style={tableCellCentered(110)}
              body={linha => (linha.isNf ? null : linha.product_code)}
            />
            <Column header="Produto" body={linha => (linha.isNf ? null : linha.product_name)} />
            <Column
              header="Qte. Caixa NF."
              style={tableCellCentered(150)}
              body={linha => renderQuantidadeAnalitico(linha, 'qte_caixa_nf')}
            />
            <Column
              header="Qte. Devolvida."
              style={tableCellCentered(150)}
              body={linha => renderQuantidadeAnalitico(linha, 'qte_devolvida')}
            />
          </DataTable>
        ) : (
          'Não existe Devolução Parcial associada a esta Ordem de Coleta'
        )}
      </div>
    </div>
  )
}

function SobraSection({ sobras }) {
  return (
    <div style={{ marginTop: 10 }}>
      <h3>Sobras</h3>
      <hr />
      <div style={{ marginTop: 15 }}>
        {sobras.length > 0 ? (
          <DataTable value={sobras}>
            <Column field="product_code" header="Código" style={tableCellCentered(80)} />
            <Column field="product_name" header="Produto" />
            <Column
              field="qte_caixas"
              header="Quantidade"
              style={tableCellCentered(150)}
              body={sobra => renderOrdemColetaQuantityCell(sobra, sobra.qte_caixas)}
            />
          </DataTable>
        ) : (
          'Não existe Sobra associada a esta Ordem de Coleta'
        )}
      </div>
    </div>
  )
}

export default connect()(withRouter(VisualizarOrdemColeta))
